
import { Loading} from 'element-ui'

let reqNumber = 0;
let loadingInstance;

function closeLoading() {
  if (reqNumber <= 0) return
  reqNumber--
  if (reqNumber === 0) {
    loadingInstance.close()
  } 
}

export const showLoading = () => {
  if (reqNumber === 0 ) {
    loadingInstance = Loading.service({
      fullscreen: true
    });
  }
  reqNumber++;
}

export const hideLoading = () => {
  setTimeout(closeLoading, 300);
}